import { render, staticRenderFns } from "./AssetView.vue?vue&type=template&id=5707669b&scoped=true"
import script from "./AssetView.vue?vue&type=script&lang=ts"
export * from "./AssetView.vue?vue&type=script&lang=ts"
import style0 from "./AssetView.vue?vue&type=style&index=0&id=5707669b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707669b",
  null
  
)

export default component.exports